export enum SponsorshipEnum {
  STATUS_1_SEND = "SEND",
  STATUS_2_REGISTER = "REGISTER",
  STATUS_3_PROC_AE = "PROC_AE",
  STATUS_3_PROC_SAP = "PROC_SAP",
  STATUS_4_OK_PROC_AE = "OK_PROC_AE",
  STATUS_4_OK_PROC_SAP = "OK_PROC_SAP",
  STATUS_5_OK_CONDITION = "OK_CONDITION",
  STATUS_6_ACCOUNT_VALID = "ACCOUNT_VALID",
  STATUS_7_ADD_STUDENT = "ADD_STUDENT",
  STATUS_8_FIRST_COURSE = "FIRST_COURSE",
  STATUS_9_COMPLET = "COMPLET",
}
export enum SponsorshipDescEnum {
  STATUS_1_SEND = "Invitation envoyée",
  STATUS_2_REGISTER = "Inscription validée avec un code de parrainage",
  STATUS_3_PROC_AE = "Début du remplissage de la procuration AE + SAP",
  STATUS_3_PROC_SAP = "Début du remplissage de la procuration SAP",
  STATUS_4_OK_PROC_AE = "Procuration AE remplie et signée",
  STATUS_4_OK_PROC_SAP = "Procuration SAP remplie et signée",
  STATUS_5_OK_CONDITION = "Conditions de service signées",
  STATUS_6_ACCOUNT_VALID = `Compte validé, avec procuration et conditions de service signées`,
  STATUS_7_ADD_STUDENT = "Ajout du premier client", // Changement effectué pour éviter l'erreur de type
  STATUS_8_FIRST_COURSE = "Premier cours suivi",
  STATUS_9_COMPLET = "Processus de parrainage complété",
}

const colorClasses = {
  SEND: "text-third border-orange bg-orange bg-opacity-10",
  REGISTER: "text-yellow-500 border-yellow-500 bg-yellow-500  bg-opacity-10",
  PROC_AE: "text-blue-400 border-blue-400 bg-blue-400 bg-opacity-10",
  PROC_SAP: "text-blue-500 border-blue-500 bg-blue-500 bg-opacity-10",
  OK_PROC_AE: "text-green-400 border-green-400 bg-green-400  bg-opacity-10",
  OK_PROC_SAP: "text-green-600 border-green-600 bg-green-600 bg-opacity-10",
  OK_CONDITION: "text-green-700 border-green-700 bg-green-700 bg-opacity-10",
  ACCOUNT_VALID: "text-gray-500 border-gray-500 bg-gray-500 bg-opacity-10",
  ADD_STUDENT: "text-purple-500 border-purple-500 bg-purple-500 bg-opacity-10",
  FIRST_COURSE: "text-indigo-600 border-indigo-600 bg-indigo-600 bg-opacity-10",
  COMPLET: "text-green-800 border-green-800 bg-green-800 bg-opacity-10",
};
export const SponsorshipEnumColor = {
  STATUS_1_SEND: { title: 'Envoyé', color: colorClasses.SEND },
  STATUS_2_REGISTER: { title: 'Inscrit', color: colorClasses.REGISTER },
  STATUS_3_PROC_AE: { title: 'Proc. AE en cours', color: colorClasses.PROC_AE },
  STATUS_3_PROC_SAP: { title: 'Proc. SAP en cours', color: colorClasses.PROC_SAP },
  STATUS_4_OK_PROC_AE: { title: 'Proc. AE validée', color: colorClasses.OK_PROC_AE },
  STATUS_4_OK_PROC_SAP: { title: 'Proc. SAP validée', color: colorClasses.OK_PROC_SAP },
  STATUS_5_OK_CONDITION: { title: 'Conditions validées', color: colorClasses.OK_CONDITION },
  STATUS_6_ACCOUNT_VALID: { title: 'Compte validé', color: colorClasses.ACCOUNT_VALID },
  STATUS_7_ADD_STUDENT: { title: 'Élève ajouté', color: colorClasses.ADD_STUDENT },
  STATUS_8_FIRST_COURSE: { title: 'Cours ajouté', color:colorClasses.FIRST_COURSE },
  STATUS_9_COMPLET: { title: 'Complet', color:colorClasses.COMPLET },
};







